import {APP, CHECKOUT} from 'constants/actions';

import {call, takeLatest} from 'redux-saga/effects';
import {getTypePage} from 'sagas/analytics/helpers/getTypePage';
import {LUX_PAGE_TYPE, ORDER_COUNTER, CUSTOM_DATA} from 'constants/analytics/speedCurve';
import {addCustomData} from 'libs/analytics/sendAnalytics';

/**
 * Get label.
 * @returns {string} label.
 */
export function* getLabel() {
    const pageType = yield call(getTypePage);
    return LUX_PAGE_TYPE[pageType];
}

/**
 * Save label.
 */
export function* saveLabel() {
    // @ts-ignore
    if (__NODEJS__) return;
    const LUX = window.LUX || {};
    const label = yield call(getLabel);
    if (!label) return;
    LUX.label = label;
}

/**
 * Tracking conversion.
 */
export function* trackingConversion() {
    yield call(addCustomData, CUSTOM_DATA.ORDER, ORDER_COUNTER);
}

/**
 * Update speed curve data.
 */
export function* updateSpeedCurveData() {
    yield call(saveLabel);
}

/**
 * Begin of saga.
 */
export default function* speedCurve() {
    yield takeLatest(APP.SAVE_LOCATION, updateSpeedCurveData);
    yield takeLatest(CHECKOUT.SAVE_ORDER_SUCCESS, trackingConversion);
}
